"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formStateWithHelpers = void 0;
function formStateWithHelpers(state) {
    return Object.assign(Object.assign({}, state), { isIdle: state.status === 'idle', isSubmitting: state.status === 'submitting', isRouting: state.status === 'routing', isLoading: state.status === 'routing' || state.status === 'submitting', isSuccess: state.status === 'success', isError: state.status === 'error' });
}
exports.formStateWithHelpers = formStateWithHelpers;
//# sourceMappingURL=helpers.js.map